import React from 'react';

import * as S from './styles';

interface Props {
  text: string;
  className?: string;
}

export const SectionDisplayText: React.FC<Props> = ({ text, className }) => {
  return <S.DisplayText className={className}>{text}</S.DisplayText>;
};

export default SectionDisplayText;
